import React, { useEffect, useState } from 'react';
import styled, { cutDates, inputNumbers, inputNumbersmall, inputStyle11, inputStyles, inputStyless, stockNumber } from '../../Utils/inputChanges';
import {
    TextField, FormControl, InputLabel, Grid, Paper,
    useMediaQuery, Button, FormHelperText, Table, TableBody, TableCell, TableContainer, Typography,
    TableRow, Autocomplete, TextareaAutosize, Checkbox,
    RadioGroup, FormControlLabel, Radio,
    CircularProgress,MenuItem,Select

} from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrentDate } from '../../Utils/Dateutils';
import DateInputComponent from '../FieldsComponents/DateInputComponent';
import { useParams } from 'react-router-dom';
import { fetchPackingData, insertPackingDCEntry } from '../../Store/PHPSlice/Packing/PackApis';
import { selectPackingData } from '../Selectors/PackSelector/PackingSelector';
import RadioComponent from '../FieldsComponents/RadioComponent';
import DateInputComponent2 from '../FieldsComponents/DateInputComponent2';
import axios from 'axios';


const DcInvoice = () => {
    const userdata = JSON.parse(localStorage.getItem('user'));
    const { Id } = useParams();
    const [formData, setFormData] = useState({
        firmId: '',
        firm: '',
        pkId: Id,
        billNo: '',
        billdt: getCurrentDate(),
        pkdt: "",
        pkMemo: '',
        transportId: '',
        transport: "",
        partyId: '',
        party: '',
        adrs: '',
        lrNo: '',
        lrdt: '',
        parcelqty: '',
        shipTo: '',
        ship_adrs: '',
        totqty: '',
        totamt: '',
        freight_ch: '0',
        other_ch: '0',
        grandtot: '',
        gst_type: 'no',
        gst: '5',
        igst: '0',
        cgst: '0',
        sgst: '0',
        state_type: '',
        discnt_type: 'percent',
        discnt_amt: '',
        discnt_val: '18.5',
        netamt: '',
        ratetype: 'MIL',   // ✅ ADD THIS
        userId: userdata?.ID
    });
    const singlePack = useSelector(selectPackingData);
    const [packData, setPackData] = useState([]);
    const [billno, setBillno] = useState();

    const [loading, setLoading] = useState(false);

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchPackingData(Id));
        fetchBillInvoiceNo();
    }, [Id]);
    // console.log(formData)
    // useEffect(() => {
    //     if (singlePack?.data) {
    //         const item = singlePack?.data;
    //         const discnt_amt = Math.round(parseFloat(item.totamt) / parseFloat(formData.discnt_val));
    //         let grandtot = parseFloat(item.totamt) - discnt_amt;
    //         setFormData(prev => ({
    //             ...prev,
    //             // billNo: billno,
    //             firm: item.firmNm,
    //             firmId: item.firmId,
    //             pkdt: item.dt,
    //             pkMemo: item.pkMemo,
    //             transport: item.transportNm,
    //             transportId: item.transptId,
    //             party: item.partyNm,
    //             partyId: item.partyId,
    //             adrs: item.partyAdrs,
    //             parcelqty: item.parcel_qty,
    //             shipTo: item.shipNm,
    //             ship_adrs: item.ship_adrs,
    //             totamt: item.totamt,
    //             totqty: item.totqty,
    //             discnt_amt: discnt_amt,
    //             state_type: item.state_type,
    //             grandtot: grandtot
    //         }));

    //     }
    //     if (singlePack?.Info && singlePack.Info?.length > 0) {
    //         const info = singlePack.Info;
    //         setPackData(info);
    //     }
    // }, [singlePack]);
    // useEffect(() => {
    //     if (billno?.data) {
    //         const values = billno?.data?.billno;
    //         setFormData(prev => ({
    //             ...prev,
    //             billNo: values
    //         }));
    //     }
    // }, [billno]);
    useEffect(() => {
    if (singlePack?.data) {
        const item = singlePack?.data;

        const updatedForm = {
            ...formData,
            firm: item.firmNm,
            firmId: item.firmId,
            pkdt: item.dt,
            pkMemo: item.pkMemo,
            transport: item.transportNm,
            transportId: item.transptId,
            party: item.partyNm,
            partyId: item.partyId,
            adrs: item.partyAdrs,
            parcelqty: item.parcel_qty,
            shipTo: item.shipNm,
            ship_adrs: item.ship_adrs,
           // totamt: item.totamt,
            totqty: item.totqty,
            state_type: item.state_type
        };

        const calculated = calculateTotals(updatedForm);

        // setFormData({
        //     ...updatedForm,
        //     ...calculated
        // });
        setFormData(prev => ({
    ...prev,
    ...updatedForm,
    ...calculated
}));
    }

    if (singlePack?.Info && singlePack.Info?.length > 0) {
        setPackData(singlePack.Info);
    }

}, [singlePack]);
useEffect(() => {
    if (packData.length > 0) {

        const totalAmount = packData.reduce((sum, item) => {
            const rate = formData.ratetype === 'SCR' ? item.scr_rate : item.mil_rate;
            return sum + (item.qty * rate);
        }, 0);

        const updated = {
            ...formData,
            totamt: totalAmount
        };

        const calculated = calculateTotals(updated);

        setFormData({
            ...updated,
            ...calculated
        });
    }

}, [packData, formData.ratetype]);
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const fetchBillInvoiceNo = async (id) => {
        try {
            const response = await axios.get(`${baseUrl}?apicall=getDCNo`);
            let itemData = response.data?.data;
            // Add new keys with the specified values
            // console.log(itemData)
            // setBillno(itemData);
            if (itemData?.billno) {
                setFormData(prev => ({
                    ...prev,
                    billNo: itemData?.billno
                }));
            }

        } catch (error) {
            console.error('Error fetching title list:', error);

        }
    };

    const isDesktop = useMediaQuery('(min-width:768px)');
    const fields = [
        { label: 'Firm', name: 'firm', type: 'readOnly' },
        { label: 'DC Date', name: 'billdt', type: 'date' },
        { label: 'DC No', name: 'billNo', type: 'readOnly' },
        { label: 'Packing Slip Date', name: 'pkdt', type: 'readOnly' },
        { label: 'Packing Slip No', name: 'pkMemo', type: 'readOnly' },
        { label: 'Transport Name', name: 'transport', type: 'readOnly' },
        { label: 'Party', name: 'party', type: 'readOnly' },
        { label: 'Address', name: 'adrs', type: 'readOnly' },
        // { label: 'Lr No.', name: 'lrNo' },
        // { label: 'Lr Date', name: 'lrdt', type: 'date' },
        { label: 'Parcel Qty', name: 'parcelqty', type: 'readOnly' },
        { label: 'Ship To', name: 'shipTo', type: 'readOnly' },
        { label: 'Ship Address', name: 'ship_adrs', type: 'readOnly' },
    ];
    

    const gstField = [
        { label: 'GST(%)', name: 'gst' },
    ];
    const options_gst = [
        { value: 'yes', label: 'Yes' },
        { value: 'no', label: 'No' },
    ];
  

    const opts_discnt_amt = [
        { value: 'percent', label: '%' },
        { value: 'rupees', label: 'Rs.' },
    ];

    const fields2 = [
        { label: 'Total Quantity', name: 'totqty', type: 'readOnly' },
        { label: 'Total Amount', name: 'totamt', type: 'readOnly' },
        { label: 'Freight Charges', name: 'freight_ch' },
    ];

    const fields21 = [
        { label: 'Other Charges', name: 'other_ch' },
        { label: 'Gross Total', name: 'grandtot', type: 'readOnly' }
    ];

    const fields4 = [
        { label: 'IGST', name: 'igst', type: 'readOnly' },
        { label: 'CGST', name: 'cgst', type: 'readOnly' },
        { label: 'SGST', name: 'sgst', type: 'readOnly' },
        { label: 'Grand Total', name: 'netamt', type: 'readOnly' }
    ];
    const calculateTotals = (updatedForm) => {
    let total = parseFloat(updatedForm.totamt) || 0;
    let freight = parseFloat(updatedForm.freight_ch) || 0;
    let other = parseFloat(updatedForm.other_ch) || 0;
    let discountVal = parseFloat(updatedForm.discnt_val) || 0;

    let discountAmt = 0;

    if (updatedForm.discnt_type === 'percent') {
        discountAmt = (discountVal / 100) * total;
    } else {
        discountAmt = discountVal;
    }

    let gross = total - discountAmt + freight + other;

    let gstAmt = 0, igst = 0, cgst = 0, sgst = 0;

    if (updatedForm.gst_type === 'yes') {
        gstAmt = (gross * parseFloat(updatedForm.gst)) / 100;

        if (updatedForm.state_type === '1') {
            igst = gstAmt;
        } else {
            cgst = gstAmt / 2;
            sgst = gstAmt / 2;
        }
    }

    let net = gross + gstAmt;

    return {
        discnt_amt: Math.round(discountAmt),
        grandtot: Math.round(gross),
        igst: Math.round(igst),
        cgst: Math.round(cgst),
        sgst: Math.round(sgst),
        netamt: Math.round(net)
    };
};
    const handleDateChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };
 const handleInputChange = (e) => {
    const { name, value } = e.target;

    const updated = {
        ...formData,
        [name]: value
    };

    const calculated = calculateTotals(updated);

    setFormData({
        ...updated,
        ...calculated
    });
};

    // const handleRadioChange = (event) => {
    //     setFormData({
    //         ...formData,
    //         [event.target.name]: event.target.value,
    //     });

    //     if (event.target.value === 'yes') {
    //         const update_gross = parseInt(formData.totamt, 10) - parseInt(formData.discnt_amt, 10) + parseInt(formData.freight_ch, 10) + parseInt(formData.other_ch, 10);

    //         let igst = 0, cgst = 0, sgst = 0;
    //         let cal_grand = Math.round(parseFloat(update_gross) * parseFloat(formData.gst) / 100);
    //         if (formData.state_type == '1') {
    //             igst = cal_grand;
    //         } else {
    //             const half_grand = (cal_grand / 2).toFixed(2);
    //             cgst = half_grand;
    //             sgst = half_grand;
    //         }
    //         let final_grand_tot = Math.round(parseInt(update_gross, 10) + parseInt(cal_grand, 10));

    //         setFormData(prevFormData => ({
    //             ...prevFormData,
    //             grandtot: update_gross,
    //             igst: igst || 0,
    //             cgst: cgst || 0,
    //             sgst: sgst || 0,
    //             netamt: final_grand_tot
    //         }));

    //     }
    //     if (event.target.value === 'no') {
    //         const gross_tot = parseInt(formData.totamt, 10) - parseInt(formData.discnt_amt, 10);
    //         const update_gross = parseInt(gross_tot, 10) + parseInt(formData.freight_ch, 10) + parseInt(formData.other_ch, 10);
    //         let igst = 0, cgst = 0, sgst = 0;
    //         let cal_grand = Math.round(parseFloat(update_gross) * parseFloat(formData.gst) / 100);
    //         if (formData.state_type == '1') {
    //             igst = 0;
    //         } else {
    //             cgst = 0;
    //             sgst = 0;
    //         }
    //         let final_grand_tot = 0;

    //         setFormData(prevFormData => ({
    //             ...prevFormData,
    //             grandtot: update_gross,
    //             igst: igst || 0,
    //             cgst: cgst || 0,
    //             sgst: sgst || 0,
    //             netamt: final_grand_tot
    //         }));
    //     }
    // };
    const handleRadioChange = (event) => {
    const updated = {
        ...formData,
        [event.target.name]: event.target.value,
    };

    const calculated = calculateTotals(updated);

    setFormData({
        ...updated,
        ...calculated
    });
};
    const handleInputComplete = (e) => {
        const { name, value } = e.target;

        switch (name) {
            case 'gst':
                if (value) {
                    const total_amt = parseInt(formData.totamt, 10);
                    const gst_amt = Math.round(total_amt * parseFloat(formData.discnt_val) / 100);
                    const grandtot2 = Math.round(total_amt - gst_amt + parseFloat(formData.other_ch) + parseFloat(formData.freight_ch));

                    let igst = 0, cgst = 0, sgst = 0, netamt = 0;
                    if (formData.state_type == '1') {
                        igst = Math.round(grandtot2 * parseFloat(value) / 100);
                        netamt = igst + grandtot2;
                    } else if (formData.state_type == '0') {
                        const diff = Math.round(grandtot2 * parseFloat(value) / 100);
                        cgst = Math.round(diff / 2);
                        sgst = Math.round(diff / 2);
                        netamt = diff + grandtot2;
                    }

                    setFormData(prev => ({
                        ...prev,
                        igst: igst || 0,
                        cgst: cgst || 0,
                        sgst: sgst || 0,
                        netamt: netamt
                    }));
                }
                break;

            case 'freight_ch':
                if (value) {
                    const total_amt = parseInt(formData.totamt, 10);
                    const gst_amt = Math.round(total_amt * parseFloat(formData.discnt_val) / 100);
                    const grandtot2 = Math.round(total_amt - gst_amt);
                    const other_ch = formData.other_ch !== '' ? parseFloat(formData.other_ch) : 0;
                    let final_grand = grandtot2 + parseFloat(value) + other_ch;
                    setFormData(prev => ({
                        ...prev,
                        grandtot: final_grand
                    }));
                    if (formData.gst_type === 'yes') {
                        let gst_cal, igst, cgst, sgst;

                        gst_cal = Math.round(final_grand * parseFloat(formData.gst) / 100);

                        if (formData.state_type == '1') {
                            igst = gst_cal;
                        } else if (formData.state_type == '0') {
                            cgst = Math.round(gst_cal / 2);
                            sgst = Math.round(gst_cal / 2);
                        }

                        let netamt = final_grand + gst_cal;
                        setFormData(prev => ({
                            ...prev,
                            grandtot: final_grand,
                            igst: igst || 0,
                            cgst: cgst || 0,
                            sgst: sgst || 0,
                            netamt: netamt
                        }));

                    }
                }
                break;
            case 'other_ch':
                if (value) {

                    const total_amt = parseInt(formData.totamt, 10);
                    const gst_amt = Math.round(total_amt * parseFloat(formData.discnt_val) / 100);
                    const grandtot2 = Math.round(total_amt - gst_amt);
                    const freight_ch = formData.freight_ch !== "" ? parseFloat(formData.freight_ch) : 0;
                    const final_grand = grandtot2 + parseFloat(value) + freight_ch;

                    if (formData.gst_type === 'yes') {
                        let gst_cal = parseFloat((final_grand * parseFloat(formData.gst) / 100).toFixed(2));
                        let igst = 0, cgst = 0, sgst = 0;

                        if (formData.state_type === '1') {
                            igst = gst_cal;
                        } else if (formData.state_type === '0') {
                            cgst = parseFloat((gst_cal / 2).toFixed(2));
                            sgst = parseFloat((gst_cal / 2).toFixed(2));
                        }

                        let netamt = Math.round((final_grand + gst_cal))
                        setFormData(prev => ({
                            ...prev,
                            grandtot: final_grand,
                            igst: igst,
                            cgst: cgst,
                            sgst: sgst,
                            netamt: netamt
                        }));
                    } else {
                        setFormData(prev => ({
                            ...prev,
                            grandtot: final_grand
                        }));
                    }

                }
                break;

        }
    }
    const tableContainerStyle = {
        marginTop: '1%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
    };
    const gstOptions = [
    { value: '5', label: '5%' },
    { value: '12', label: '12%' },
    { value: '18', label: '18%' }
];

    const rateOptions = [
    { value: 'MIL', label: 'Mil To Party' },
     { value: 'SCR', label: 'SCR To Mil' }
   
];
    const webkitScrollbarStyle = {
        overflowX: 'auto',
        overflowY: 'hidden',
        WebkitOverflowScrolling: 'touch',
    };

    // function postObj(formData, packData) {
    //     const totamt = formData.netamt !== '' ? formData.netamt : formData.grandtot;
    //     const discnt_type = formData.discnt_type === 'percent' ? '%' : 'Rs';
    //     // const discnt_type = formData.discnt_type;
    //     const gst_type = formData.gst_type === 'yes' ? '1' : '0';

    //     const data = {
    //         dt: formData.billdt,
    //         pkId: formData.pkId,
    //         billNo: formData.billNo,
    //         firmId: formData.firmId,
    //         partyId: formData.partyId,
    //         total_amt: formData.totamt,
    //         discnt_type: discnt_type,
    //         discnt_val: formData.discnt_val,
    //         discnt_amt: formData.discnt_amt,
    //         freight_ch: formData.freight_ch,
    //         other_ch: formData.other_ch,
    //         transport: formData.transport,
    //         lrno: formData.lrNo,
    //         lrdt: formData.lrdt,
    //         party_state: formData.state_type,
    //         firm_tax_sts: gst_type,
    //         gst_val: formData.gst,
    //         igst: formData.igst,
    //         cgst: formData.cgst,
    //         sgst: formData.sgst,
    //         net_amt: totamt,
    //         shipto: formData.shipTo,
    //         ship_adrs: formData.ship_adrs,
    //         parcelqty: formData.parcelqty,
    //         totqty: formData.totqty,
    //         userId: formData.userId,
    //         pkInfo: packData,
    //         pkdata: formData.pkId
    //     };
    //     return data;
    // };

    function postObj(formData, packData) {

    const totamt = formData.netamt !== '' ? formData.netamt : formData.grandtot;
    const discnt_type = formData.discnt_type === 'percent' ? '%' : 'Rs';
    const gst_type = formData.gst_type === 'yes' ? '1' : '0';

    const updatedPackData = packData.map(item => {
        const rate = formData.ratetype === 'SCR' ? item.scr_rate : item.mil_rate;
        const total = item.qty * rate;

        return {
            ...item,
            rate: rate,
            tot: total

        };
    });

    const data = {
        dt: formData.billdt,
        pkId: formData.pkId,
        billNo: formData.billNo,
        firmId: formData.firmId,
        partyId: formData.partyId,
        total_amt: formData.totamt,
        discnt_type: discnt_type,
        discnt_val: formData.discnt_val,
        discnt_amt: formData.discnt_amt,
        freight_ch: formData.freight_ch,
        other_ch: formData.other_ch,
        transport: formData.transport,
        lrno: formData.lrNo,
        lrdt: formData.lrdt,
        party_state: formData.state_type,
        firm_tax_sts: gst_type,
        gst_val: formData.gst,
        igst: formData.igst,
        cgst: formData.cgst,
        sgst: formData.sgst,
        net_amt: totamt,
        shipto: formData.shipTo,
        ship_adrs: formData.ship_adrs,
        parcelqty: formData.parcelqty,
        totqty: formData.totqty,
        userId: formData.userId,
        pkInfo: updatedPackData,   // ✅ updated
        pkdata: formData.pkId
    };

    return data;
}
    const handleSubmit = async (e) => {
        e.preventDefault();


      

        setLoading(true);

        try {
            const finalObject = postObj(formData, packData);
            //console.log(finalObject)

            const result = await dispatch(insertPackingDCEntry(finalObject)).unwrap();
            console.log('POST request successful!', result);
            alert("Records Inserted");
            window.close();
        } catch (error) {
            console.error('Error while making POST request:', error);
        } finally {
            setLoading(false);
        }

    };

    // console.log("prevPackData",packData);
    const grandTotal = packData.reduce((sum, item) => {
    const rate = formData.ratetype === 'SCR' ? item.scr_rate : item.mil_rate;
    return sum + (item.qty * rate);
}, 0);
    return (
        <>
            <div style={{ margin: '1% 0.5%' }}>
                <h2 style={{ textAlign: 'center' }}>Generate DC</h2>

                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={0.5}>

                                {fields.map((field) => (
                                    <DateInputComponent2
                                        key={field.name}
                                        formData={formData}
                                        handleDateChange={handleDateChange}
                                        handleInputChange={handleInputChange}
                                        styled={styled}
                                        inputStyles={inputStyles}
                                        isDesktop={isDesktop}
                                        field={field}
                                        handleInputComplete={handleInputComplete}
                                    />
                                ))}
                               
                                  {/* <Grid item xs={12} md={6}>
    <Grid container alignItems="center" spacing={7}>
        
        <Grid item>
            <Typography variant="body2" sx={{ fontWeight: 500 }}>
                Type of Rate :
            </Typography>
        </Grid>

        <Grid item>
            <FormControl size="small" sx={{ minWidth: 240 }}>
                <Select
                    value={formData.ratetype}
                    onChange={handleInputChange}
                    name="ratetype"
                >
                    {rateOptions.map((opt) => (
                        <MenuItem key={opt.value} value={opt.value}>
                            {opt.label}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Grid>

    </Grid>
</Grid> */}
                                {Array.isArray(packData) && packData.length > 0 &&
                                    <>
                                        <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                            <Table style={isDesktop ? { width: '100%' } : { width: '100%' }}>
                                                <TableBody>

                                                    <TableRow>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>SR.NO.</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>PARTICULARS</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>SIZE</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>RATE</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>QTY</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>AMOUNT</TableCell>
                                                    </TableRow>
                                                    {
                                                       packData.map((item, index) => {

    const rate = formData.ratetype === 'SCR' ? item.scr_rate : item.mil_rate;
    const total = item.qty * rate;

    return (
        <TableRow key={index}>

            <TableCell sx={{ p: 1, border: '1px solid #000' }} align="center">
                {index + 1}
            </TableCell>

            <TableCell sx={{ p: 1, border: '1px solid #000' }} align="center">
                {item.itemNm}
            </TableCell>

            <TableCell sx={{ p: 1, border: '1px solid #000' }} align="center">
                {item.size}
            </TableCell>

            <TableCell sx={{ p: 1, border: '1px solid #000' }} align="center">
                {rate}
            </TableCell>

            <TableCell sx={{ p: 1, border: '1px solid #000' }} align="center">
                {item.qty}
            </TableCell>

            <TableCell sx={{ p: 1, border: '1px solid #000' }} align="center">
                {total}
            </TableCell>

        </TableRow>
    );
})
                                                    }
                                                </TableBody>
                                            </Table>
                                        </TableContainer>

                                    </>
                                }

                                <RadioComponent
                                    label='GST'
                                    name='gst_type'
                                    value={formData.gst_type}
                                    options={options_gst}
                                    onChange={handleRadioChange}
                                    isDesktop={true}
                                />

                                {formData.gst_type === 'yes' ?
                                
                                    <>
                                        {/* {gstField.map((field) => (
                                            <DateInputComponent2
                                                key={field.name}
                                                formData={formData}
                                                handleDateChange={handleDateChange}
                                                handleInputChange={handleInputChange}
                                                styled={styled}
                                                inputStyles={inputStyles}
                                                isDesktop={isDesktop}
                                                field={field}
                                                handleInputComplete={handleInputComplete}
                                            />
                                        ))} */}
                                        <Grid item xs={12} md={6}>
    <Grid container alignItems="center" spacing={11}>
        
        {/* Label */}
        <Grid item>
            <Typography variant="body2" sx={{ fontWeight: 500 }}>
                GST % :
            </Typography>
        </Grid>

        {/* Small Dropdown */}
        <Grid item>
            <FormControl size="small" sx={{ minWidth: 240 }}>
                <Select
                    value={formData.gst}
                    onChange={handleInputChange}
                    name="gst"
                    displayEmpty
                >
                    {gstOptions.map((opt) => (
                        <MenuItem key={opt.value} value={opt.value}>
                            {opt.label}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Grid>

    </Grid>
</Grid>
                      </>
                                    : (
                                        <Grid item xs={12} md={6}>
                                        </Grid>
                                    )
                                }

                                {fields2.map((field) => (
                                    <DateInputComponent2
                                        key={field.name}
                                        formData={formData}
                                        handleDateChange={handleDateChange}
                                        handleInputChange={handleInputChange}
                                        styled={styled}
                                        inputStyles={inputStyles}
                                        isDesktop={isDesktop}
                                        field={field}
                                        handleInputComplete={handleInputComplete}
                                    />
                                ))}

                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel htmlFor="discnt_amt">Discount Amount:</InputLabel>
                                            <RadioGroup row name="discnt_type" value={formData.discnt_type} onChange={handleRadioChange}>
                                                {opts_discnt_amt.map((option) => (
                                                    <FormControlLabel
                                                        key={option.value}
                                                        value={option.value}
                                                        control={<Radio />}
                                                        label={option.label}
                                                    />
                                                ))}
                                                {/* <input type="text" name='discnt_val' value={formData.discnt_val} onChange={handleInputChange}
                                                    style={{ width: '50px', height: '25px', paddingLeft: '5px', marginTop: '1px', color: 'red', fontSize: '15px' }} /> */}
                                            </RadioGroup>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth style={{ display: 'flex', flexDirection: 'row', gap: '10px' }}>
                                                <TextField
                                                    id="discnt_val"
                                                    name="discnt_val"
                                                    value={formData.discnt_val}
                                                    onChange={handleInputChange}
                                                    inputProps={{ style: styled.inputs }}
                                                    sx={inputNumbersmall}
                                                />
                                                <TextField
                                                    id="discnt_amt"
                                                    name="discnt_amt"
                                                    value={formData.discnt_amt}
                                                    onChange={handleInputChange}
                                                    inputProps={{ style: styled.input, readOnly: true }}
                                                    sx={inputStyle11}
                                                />
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                {fields21.map((field) => (
                                    <DateInputComponent2
                                        key={field.name}
                                        formData={formData}
                                        handleDateChange={handleDateChange}
                                        handleInputChange={handleInputChange}
                                        styled={styled}
                                        inputStyles={inputStyles}
                                        isDesktop={isDesktop}
                                        field={field}
                                        handleInputComplete={handleInputComplete}
                                    />
                                ))}

                                {formData.gst_type === 'yes' &&
                                    <>
                                        {
                                            fields4.map((field) => (
                                                <DateInputComponent
                                                    key={field.name}
                                                    formData={formData}
                                                    handleDateChange={handleDateChange}
                                                    handleInputChange={handleInputChange}
                                                    styled={styled}
                                                    inputStyles={inputStyles}
                                                    isDesktop={isDesktop}
                                                    field={field}
                                                />
                                            ))
                                        }
                                    </>

                                }

                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit} disabled={loading === true}>
                                        {
                                            loading === true ?
                                                <><CircularProgress size="20px" /> wait...</> :
                                                "Submit"
                                        }
                                    </Button>
                                </Grid>

                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default DcInvoice;
